import { HaendlerState } from './store/states/stammdaten/haendler.state';
import { CoreModule } from '@abp/ng.core';
import { SettingManagementConfigModule } from '@abp/ng.setting-management.config';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsModule } from '@ngxs/store';
import { AccountConfigModule } from '@volo/abp.ng.account.config';
import { AuditLoggingConfigModule } from '@volo/abp.ng.audit-logging.config';
import { IdentityServerConfigModule } from '@volo/abp.ng.identity-server.config';
import { IdentityConfigModule } from '@volo/abp.ng.identity.config';
import { LanguageManagementConfigModule } from '@volo/abp.ng.language-management.config';
import { SaasConfigModule } from '@volo/abp.ng.saas.config';
import { LAYOUTS, HttpErrorComponent } from '@volo/abp.ng.theme.lepton';
import { OAuthModule } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { BasisAlphaCodesState } from './store/states/central/basisAlphaCodes.state';
import { ParkSmartModule } from './ParkSmart/ParkSmart.module';

const LOGGERS = [NgxsLoggerPluginModule.forRoot({ disabled: false })];
@NgModule({
  declarations: [AppComponent],
  imports: [
    ThemeSharedModule.forRoot({
      httpErrorConfig: {
        errorScreen: {
          component: HttpErrorComponent,
          forWhichErrors: [401, 403, 404, 500],
          hideCloseIcon: true,
        },
      },
    }),
    CoreModule.forRoot({
      environment,
      requirements: {
        layouts: [...LAYOUTS],
      },
    }),
    AccountConfigModule.forRoot({ redirectUrl: '/' }),
    IdentityConfigModule,
    LanguageManagementConfigModule,
    SaasConfigModule,
    AuditLoggingConfigModule,
    IdentityServerConfigModule,
    SettingManagementConfigModule,
    OAuthModule.forRoot(),
    NgxsModule.forRoot([HaendlerState, BasisAlphaCodesState]),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    ParkSmartModule,

    ...(environment.production ? [] : LOGGERS),
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
